var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.32255 0.583245C1.4595 0.582779 1.59481 0.613004 1.71854 0.671697C1.84227 0.73039 1.95128 0.816061 2.03755 0.922412L6.46505 6.42241C6.59988 6.58643 6.67358 6.79217 6.67358 7.00449C6.67358 7.21682 6.59988 7.42256 6.46505 7.58658L1.88172 13.0866C1.72613 13.2738 1.50254 13.3915 1.26015 13.4138C1.01776 13.4362 0.776418 13.3613 0.58922 13.2057C0.402021 13.0501 0.284299 12.8266 0.261951 12.5842C0.239603 12.3418 0.314459 12.1004 0.470053 11.9132L4.56755 6.99991L0.607554 2.08658C0.495462 1.95202 0.424257 1.78818 0.402368 1.61443C0.380478 1.44067 0.408819 1.26428 0.484037 1.10613C0.559255 0.947984 0.678201 0.814691 0.826802 0.722024C0.975403 0.629359 1.14744 0.581199 1.32255 0.583245Z","fill":"white"}));
}

Arrow.defaultProps = {"width":"7","height":"14","viewBox":"0 0 7 14","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
